import axios from "axios";
import { getAccessToken, getRefreshToken, refreshToken, logout } from "../API/auth";
import { getTenantFromHostname } from "../API/utils";
import { notification } from "antd";

// Base URL del backend
/* const API_URL = "http://tenant1.localhost/api/auth"; */
const tenant = getTenantFromHostname();
//const API_URL = `https://${tenant}-api.eacc.solutions/api`;
const API_URL =
  tenant === "eaccadmin"
    ? `https://${tenant}.exaamericas.com/api`
    : `https://${tenant}-api.eacc.solutions/api`;

// Crear instancia de Axios
export const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Interceptor de solicitud: Agregar el token a cada request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta: Manejo de errores 401 y refresco de token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest.url === 'auth/token/refresh/') {
      console.error("El refresh token falló. No se reintentará.");
      logout();
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      const refresh = getRefreshToken();
      if (!refresh) {
        console.error("No hay refresh token, cerrando sesión...");
        logout();
        return Promise.reject(error);
      }

      originalRequest._retry = true;
      try {
        console.log("Intentando renovar el access token...");
        const newAccessToken = await refreshToken();
        if (!newAccessToken) {
          console.error("No se pudo renovar el token, cerrando sesión...");
          logout();
          return Promise.reject(error);
        }

        // Actualizar headers y reintentar la solicitud original
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        console.error("Error en la renovación del token, cerrando sesión...");
        logout();
        return Promise.reject(refreshError);
      }
    }

    // Manejo de errores 500: mostrar notificación global
    if (error.response?.status === 500) {
      notification.error({
        message: 'Error del servidor',
        description: 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente más tarde.',
        duration: 3,
        key: 'server-error-500'
      });
    }

    if (error.response?.status === 404) {
      notification.warning({
        message: 'Recurso no encontrado',
        description: 'El recurso que buscas no existe o ha sido eliminado.',
        duration: 3,
        key: 'not-found-404'
      });
    }

    // 404 o 500: redirigir a /404
    /* if (error.response?.status === 404 || error.response?.status === 500) {
      window.location.href = "/404";
      return; // corta la ejecución
    } */

    return Promise.reject(error);
  }
);